(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[890],{

/***/ 1162:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms",
      function () {
        return __webpack_require__(6134);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var components_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1258);



//* Components

var CollapseItems = function(_param) {
    var data = _param.data, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "data"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isActive = ref[0], setIsActive = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "accordion",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "accordionSummary",
                onClick: function() {
                    setIsActive(!isActive);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        tag: "h7",
                        className: "h7 geoSemiBold accordionTitle",
                        text: data.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "icon ".concat(isActive ? "active" : "")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "collapse ".concat(isActive ? "collapseOpened" : ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: data.text
                    },
                    className: "dangerHTML"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CollapseItems);


/***/ }),

/***/ 6134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ terms; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./context/index.js + 8 modules
var context = __webpack_require__(7370);
// EXTERNAL MODULE: ./components/common/Page/index.js + 2 modules
var Page = __webpack_require__(1286);
// EXTERNAL MODULE: ./components/common/Text/index.js
var Text = __webpack_require__(1258);
// EXTERNAL MODULE: ./components/common/Container/index.js + 1 modules
var Container = __webpack_require__(8892);
// EXTERNAL MODULE: ./components/pages/Terms/CollapseItem/index.js
var CollapseItem = __webpack_require__(9194);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./styles/pages/TermsStyle.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	--contentLeftFix: var(--sp11x);\n	--contentTop: var(--sp22x);\n	--accordionWrapperTop: var(--sp13x);\n	--accordionWrapperLeft: var(--sp22x);\n	--accordionPaddings: var(--sp7x);\n	--accordionTitleWidth: 98%;\n\n	margin-left: var(--contentLeftFix);\n	padding-top: var(--contentTop);\n	margin-bottom: var(--sectionMarginBottom);\n	word-break: break-word;\n\n	.description {\n		margin-top: var(--sp4x);\n	}\n	.accordionWrapper {\n		margin-top: var(--accordionWrapperTop);\n		padding-left: var(--accordionWrapperLeft);\n		margin-left: auto;\n		width: 100%;\n\n		.accordion {\n			box-shadow: none;\n			border-top: 1px solid var(--grey);\n			background: transparent;\n			overflow: hidden;\n\n			.collapse {\n				max-height: 0;\n				transition: max-height var(--trTime2) ease-in;\n			}\n\n			.collapseOpened {\n				max-height: 100%;\n				visibility: visible;\n				transition: max-height var(--trTime2) ease-out;\n			}\n			.accordionSummary {\n				margin: 0;\n				padding: 0;\n				position: relative;\n				.accordionTitle {\n					padding: var(--accordionPaddings) 0 var(--accordionPaddings) 0;\n					width: var(--accordionTitleWidth);\n				}\n				.icon {\n					position: absolute;\n					right: 0;\n					width: var(--sp4x);\n					height: var(--sp0-5x);\n					background: var(--black);\n					top: 50%;\n                    cursor: pointer;\n\n					&.active {\n						&:after {\n							opacity: 0;\n						}\n					}\n				}\n\n				.icon::after {\n					content: '';\n					width: var(--sp4x);\n					height: var(--sp0-5x);\n					background: var(--black);\n					position: absolute;\n					transform: rotate(90deg);\n					opacity: 1;\n					transition: all 350ms ease;\n				}\n			}\n			.dangerHTML {\n				font-family: geoRegular;\n				padding: 0 0 var(--accordionPaddings) 0;\n				p {\n					font-size: var(--h7);\n				}\n			}\n		}\n		.accordion:last-child {\n			border-bottom: 1px solid var(--grey);\n		}\n	}\n\n	@media screen and (max-width: ",
        ") and (min-width: ",
        ") {\n		--contentLeftFix: var(--sp4x);\n		--contentTop: var(--sp16-5x);\n		--accordionWrapperTop: var(--sp12x);\n		--accordionWrapperLeft: var(--sp17x);\n		--accordionPaddings: var(--sp6x);\n		--accordionTitleWidth: 97%;\n	}\n	@media screen and (max-width: ",
        ") and (min-width: ",
        ") {\n		--contentLeftFix: var(--sp6x);\n		--contentTop: var(--sp13-5x);\n		--accordionWrapperTop: var(--sp10x);\n		--accordionWrapperLeft: var(--sp15x);\n		--accordionPaddings: var(--sp5x);\n		--accordionTitleWidth: 96%;\n	}\n	@media screen and (max-width: ",
        ") and (min-width: ",
        ") {\n		--contentLeftFix: var(--sp5x);\n		--contentTop: var(--sp12-5x);\n		--accordionWrapperTop: var(--sp9x);\n		--accordionWrapperLeft: var(--sp13x);\n		--accordionPaddings: var(--sp4x);\n		--accordionTitleWidth: 96%;\n	}\n	@media screen and (max-width: ",
        ") and (min-width: ",
        ") {\n		--contentLeftFix: 0;\n		--contentTop: var(--sp10x);\n		--accordionWrapperTop: var(--sp7x);\n		--accordionWrapperLeft: 0;\n		--accordionPaddings: var(--sp3x);\n		--accordionTitleWidth: 96%;\n	}\n	@media screen and (max-width: ",
        ") and (min-width: ",
        ") {\n		--contentLeftFix: 0;\n		--contentTop: var(--sp10x);\n		--accordionWrapperTop: var(--sp7x);\n		--accordionWrapperLeft: 0;\n		--accordionPaddings: var(--sp3x);\n		--accordionTitleWidth: 94%;\n	}\n	@media screen and (max-width: ",
        ") {\n		--contentLeftFix: 0;\n		--contentTop: var(--sp9x);\n		--accordionWrapperTop: var(--sp6x);\n		--accordionWrapperLeft: 0;\n		--accordionPaddings: var(--sp3x);\n		--accordionTitleWidth: 90%;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var TermsStyle = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), function(props) {
    return props.theme.mediaQuery.DesktopSizeLMin;
}, function(props) {
    return props.theme.mediaQuery.DesktopSizeM;
}, function(props) {
    return props.theme.mediaQuery.DesktopSizeMMin;
}, function(props) {
    return props.theme.mediaQuery.DesktopSizeS;
}, function(props) {
    return props.theme.mediaQuery.DesktopSizeSMin;
}, function(props) {
    return props.theme.mediaQuery.DesktopSizeXS;
}, function(props) {
    return props.theme.mediaQuery.DesktopSizeXSMin;
}, function(props) {
    return props.theme.mediaQuery.LaptopSize;
}, function(props) {
    return props.theme.mediaQuery.LaptopSizeMin;
}, function(props) {
    return props.theme.mediaQuery.TabletSize;
}, function(props) {
    return props.theme.mediaQuery.TabletSizeMin;
});
/* harmony default export */ var pages_TermsStyle = (TermsStyle);

;// CONCATENATED MODULE: ./pages/terms/index.js


//* HOC's

//* Components




//* Style

var Terms = /*#__PURE__*/ (0,react.memo)(function(param) {
    var pages = param.pages, pageParams = param.pageParams, selectedLang = param.selectedLang;
    //! Page Data
    var pageData = (0,react.useMemo)(function() {
        var ref;
        return pages === null || pages === void 0 ? void 0 : (ref = pages[pageParams.name]) === null || ref === void 0 ? void 0 : ref[selectedLang];
    }, [
        pages,
        selectedLang,
        pageParams.name
    ]);
    var storeCollapse = function(conditions) {
        return conditions === null || conditions === void 0 ? void 0 : conditions.map(function(el, ind) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseItem/* default */.Z, {
                data: el
            }, ind);
        });
    };
    return pageData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        className: "terms",
        meta: pageData.content.meta,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_TermsStyle, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        tag: "h3",
                        className: "h3 grandItalic",
                        text: pageData.content.terms.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        tag: "h7",
                        className: "h7 geoRegular description",
                        text: pageData.content.terms.text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "accordionWrapper",
                        children: storeCollapse(pageData.content.terms.conditions)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        tag: "h3",
                        className: "h3 grandItalic",
                        text: pageData.content.general.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        tag: "h7",
                        className: "h7 geoRegular description",
                        text: pageData.content.general.text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "accordionWrapper",
                        children: storeCollapse(pageData.content.general.conditions)
                    })
                ]
            })
        })
    }) : null;
});
/* harmony default export */ var terms = ((0,context/* withDataContext */.hX)(Terms, [
    "pages"
]));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(1162); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);